import _ from 'lodash'

export default {
  inject: ['$validator'],
  computed: {
    isDirty () {
      return this.model !== null;
    },
    newName () {
      if (this.validScope) {
        return this.validScope + '.' + this.name
      } else {
        return this.name
      }
    }
  },
  data () {
    return {
      model: this.resolveValue(),
    }
  },
  methods: {
    resolveValue () {
      if (this.values && this.lang) {
        if (this.resolver) {
          return this.resolver(this.values[this.lang.code])
        }

        return this.values[this.lang.code]
      }

      return this.value ? this.value : '';
    }
  },
  props: {
    name: {
      default: '',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    value: {
      default: '',
      type: [Number, String, Object, Boolean]
    },
    values: {
      default: () => undefined,
      type: Object,
    },
    lang: {
      default: () => { return {} },
      type: Object,
    },
    rules: {
      default: () => { return {} },
    },
    disabled: {
      default: false,
      type: Boolean
    },
    resolver: {
      default: null,
      type: Function
    },
    type: {
      default: null,
      type: String
    },
    maxlength: {
      default: null,
      type: String
    },
    scope: {
      default: null,
      type: String
    },
    validScope: {
      default: null,
      type: String
    }
  },
  watch: {
    value (value) {
      this.model = value
    },
    model (value) {
      this.$emit('input', value);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/admin/mixins/field.js